module.exports = __webpack_public_path__ + "img/1611.a359c8b9.svg";